import { ReactNode, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { promoStore } from 'widgets/avia'

import userStore from 'entities/user/module/user-store'

import { BannerSale } from 'shared/ui/banner-sale'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

interface Props {
  children: ReactNode
}

const promoKey = 'azal'

const promoId = ''

const isShowBanner = false

export const BannerMain = ({ children }: Props) => {
  const navigate = useNavigate()
  const { openDialog, closeDialog } = useDialogBottomSheet()

  const onShowBanner = () => {
    const isAzalPopUp = Boolean(userStore.getClientStateString(promoKey) || '')

    if (isAzalPopUp) return

    openDialog({
      isDialog: false,
      child: (
        <BannerSale
          keyStorage={promoKey}
          onClose={closeDialog}
          onContinue={() => {
            const promo = promoStore.getCurrentPromo(promoId, 'avia')

            if (promo) navigate(RoutingPaths.promo.path(promo.id))

            closeDialog()
          }}
        />
      ),
    })
  }

  useEffect(() => {
    if (isShowBanner) onShowBanner()
  }, [])

  return <div>{children}</div>
}
